import alerts from '@/store/activities/alerts';
import rules from '@/store/activities/rules';
import appliedRules from '@/store/activities/appliedRules';
import { Dispatch } from 'vuex';

export default {
	namespaced: true,
	modules: {
		alerts,
		appliedRules,
		rules,
	},
	actions: {
		async fetchAllActivities({ dispatch }: { dispatch: Dispatch }): Promise<void> {
			await Promise.all([
				dispatch('alerts/fetchAlerts'),
				dispatch('rules/fetchRuleTemplates'),
				dispatch('rules/fetchRules'),
				dispatch('rules/fetchInternalRules'),
				dispatch('appliedRules/fetchAppliedRules'),
				dispatch('appliedRules/fetchAppliedInternalRules'),
			]);
		},

		cleanAllActivities({ dispatch }: { dispatch: Dispatch }): void {
			dispatch('alerts/cleanAllAlert');
			dispatch('rules/cleanRuleTemplates');
			dispatch('rules/cleanRule');
			dispatch('rules/cleanInternalRule');
			dispatch('appliedRules/cleanAppliedRule');
			dispatch('appliedRules/cleanAppliedInternalRule');
		},
	},
};
